<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_ix"></a><strong>THE<br/><br/><span class="big1">I</span>LLUMINATOR</strong></p>
<p class="center"><img alt="Image" src="images/halftitle-img.jpg"/><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?4c86c32a